import '../upgradeApi.less';

import { Button } from '@bfe/moly';
import { message } from 'antd';
import { useState } from 'react';

import ByModal from '@/components/ByModal';
import { useErrorMsg } from '@/hooks/useErrorMsg';
import { useUserProfile } from '@/hooks/useUserProfile';
import { useI18nContext } from '@/i18n/I18n';
import { IErrorType } from '@/pages/security/types';
import { upgradeApi } from '@/services/apiManagement';

export enum UPGRADE_STATUS {
  PROCESS = 'PROCESS',
  SUCCESS = 'SUCCESS',
  FAIL = 'FAIL',
}

const ConfirmModal = ({
  visible,
  onConfirm,
  onCancel,
}: {
  visible: boolean;
  onConfirm: (status: UPGRADE_STATUS, failCodes?: string[]) => void;
  onCancel: () => void;
}) => {
  const [$t] = useI18nContext();
  const [loading, setLoading] = useState(false);
  const { mutate } = useUserProfile();
  const { msgError } = useErrorMsg(mutate);

  const handleConfirm = () => {
    setLoading(true);
    upgradeApi({ upTo: 'UTA_PRO' })
      .then((data: any) => {
        if (data.retCode !== 0) {
          msgError({
            ret_code: data.retCode,
            ret_msg: data.retMsg,
          } as IErrorType);
          return;
        }
        const { status, relieveLimitBizResponse } = data?.result || {};
        let errorCodes = [];
        if (status === UPGRADE_STATUS.SUCCESS) {
          message.success($t('UpgradeToApiProSuccess'));
        } else {
          if (
            status === UPGRADE_STATUS.FAIL &&
            Array.isArray(relieveLimitBizResponse)
          ) {
            errorCodes = relieveLimitBizResponse.map(
              ({ relieveLimitCode }) => relieveLimitCode,
            );
          }
        }
        onConfirm(status, errorCodes);
      })
      .catch((err: any) => {
        if (err.ret_code && err.ret_code !== -200) {
          msgError({ ...err, ret_code: err.retCode, ret_msg: err.retMsg });
        } else {
          message.error($t('networkError'));
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handelCancel = () => {
    onCancel();
  };

  return (
    <ByModal
      visible={visible}
      modalProps={{
        centered: true,
      }}
      ByFooter={[
        <div className="upgrade-api__confirm--footer" key="footer">
          <Button
            onClick={handleConfirm}
            key="confirm"
            variant="primary"
            className="bybit-btn-primary"
            loading={loading}
            block
          >
            {$t('Confirm')}
          </Button>
          <Button
            key="cancel"
            onClick={handelCancel}
            disabled={loading}
            variant="secondary"
            block
          >
            {$t('Cancel')}
          </Button>
        </div>,
      ]}
      onCancel={handelCancel}
      title={$t('UpgradeToApiProConfirm.title')}
      newStyle
    >
      <p className="upgrade-api__confirm--desc">
        {$t('UpgradeToApiProConfirm.desc')}
      </p>
      <ul className="upgrade-api__confirm--status-desc">
        <li
          dangerouslySetInnerHTML={{
            __html: $t('UpgradeToApiProConfirm.status1'),
          }}
        ></li>
        <li
          dangerouslySetInnerHTML={{
            __html: $t('UpgradeToApiProConfirm.status2'),
          }}
        ></li>
        <li
          dangerouslySetInnerHTML={{
            __html: $t('UpgradeToApiProConfirm.status3'),
          }}
        ></li>
      </ul>
    </ByModal>
  );
};

export default ConfirmModal;
